import { useEffect, forwardRef, useImperativeHandle, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import { userState } from "../interface/MainInterface";
import { useWindowSize } from "../utils/useWindowSize";

import SearchModal from "./SearchModal";

import "./Header.css";
import { appConfig } from "../config/Config";

interface propsType {
  userState: userState;
}

const Header = (props: propsType, ref: any) => {
  let navigate = useNavigate();
  const dropdownRef: any = useRef();
  const searchModalRef: any = useRef();
  const windowSize = useWindowSize();
  const [expand, setExpand] = useState(false);
  const [openDropDown, setOpenDropDown] = useState(false);
  const [tmpKeyFlag, setTmpKeyFlag] = useState(false);

  const stateInfo: URLSearchParams = new URLSearchParams(
    window.location.search
  );

  useEffect(() => {
    if (stateInfo.get("tKey")) {
      setTmpKeyFlag(true);
    }
    window.addEventListener("click", evtClick);
    return () => {
      window.removeEventListener("click", evtClick);
    };
  }, []);

  // 검색 Drawer 열기
  const openSearchModal = () => {
    searchModalRef.current.open();
    setExpand(false);
  };

  const toggleDropdown = () => {
    setOpenDropDown(!openDropDown);
  };

  // 스크랩 보드
  const viewScrapBoard = () => {
    navigate("/scrapList");
  };

  const goReportList = () => {
    navigate("/reportList");
  };

  const goRunwayData = () => {
    navigate("/runway");
  }

  const goUserMng = () => {
    navigate("/userMng");
  };

  const goStatistic = () => {
    navigate("/statistic");
  };

  const goSetting = () => {
    navigate("/setting");
  };

  // 로그아웃
  const signOut = async () => {
    if (!window.confirm("로그아웃 하시겠습니까?")) return;
    window.localStorage.removeItem(appConfig.sessionName);
    await Auth.signOut();
    setExpand(false);
    window.location.href = "/";
  };

  const expandMenu = () => {
    setExpand(true);
  };

  const evtClick = (e: any) => {
    if (e.target !== document.getElementById("openModalBtn")) {
      setExpand(false);
    }
  };

  // 부모 Component에서 접근 가능하도록 함수 전달.
  useImperativeHandle(ref, () => ({}));

  return (
    <>
      <header>
        <h1>
          <a
            href="/"
            onClick={(e) => {
              if (tmpKeyFlag) {
                e.preventDefault(); // 클릭 막기
              }
            }}
            aria-disabled={tmpKeyFlag} // 접근성 대응
            style={{ cursor: tmpKeyFlag ? "default" : "pointer" }}
          >
            AI Trend Brief
          </a>
        </h1>
        {!tmpKeyFlag && (
          windowSize.width > 1023 ? (
            <div className="btn-wrap">
              <button id="openModalBtn" className="key-search" onClick={openSearchModal}>
                <span>키워드검색</span>
                {/* <i><img src="/images/icon-search.png" alt="" /></i> */}
              </button>
              <button id="openModalBtn" className="scrap-board" onClick={viewScrapBoard}>
                <span>스크랩함</span>
                {/* <i><img src="/images/icon-briefbox.png" alt="" /></i> */}
              </button>
              {props.userState.isAdmin && (
                <button id="openModalBtn" className="report-board" onClick={goReportList}>
                  <span>발행된 리포트</span>
                  {/* <i><img src="/images/icon-magazine.png" alt="" /></i> */}
                </button>
              )}
              {props.userState.isSuperAdmin && windowSize.width > 1439 && (
                <>
                {/* <button id="openModalBtn" className="runway-data" onClick={goRunwayData} style={{ backgroundColor: '#D0FF00' }}>
                  <span>RUNWAY DATA</span>
                </button> */}

                <div ref={dropdownRef} style={{ alignContent: "center" }}>
                  <button id="openModalBtn" className="user-mng" onClick={toggleDropdown}>
                    <span>관리자 페이지</span>
                    {/* <i><img src="/images/icon-setting.png" alt="" /></i> */}
                  </button>
                </div>
                </>
              )}
              <button className="logout" onClick={signOut}>로그아웃</button>
            </div>
          ) : (
            <div className="btn-wrap slide-left">
              <button id="openModalBtn" className="key-search" onClick={openSearchModal}>
                <span>키워드검색</span>
                <i><img src="/images/icon-search.png" alt="" /></i>
              </button>
              <button id="openModalBtn" className="scrap-board" onClick={viewScrapBoard}>
                <span>스크랩함</span>
                <i><img src="/images/icon-briefbox.png" alt="" /></i>
              </button>
              {props.userState.isAdmin && (
                <button id="openModalBtn" className="report-board" onClick={goReportList}>
                  <span>발행된 리포트</span>
                  <i><img src="/images/icon-magazine.png" alt="" /></i>
                </button>
              )}
              <button className="logout" onClick={signOut}>로그아웃</button>
            </div>
          )
        )}

        <div id="modal" className="search-modal">
          <div className="modal-content">
            <span id="closeModalBtn" className="modal-close" title="닫기"></span>
            <div>
              <dl className="search-wrap">
                <dt>키워드 검색</dt>
                <dd>
                  <input type="text" placeholder="어떤 키워드로 검색할까요?" />
                  <button className="btn-search-modal" title="검색하기"></button>
                </dd>
              </dl>
              <dl className="hotkw-list">
                <dt>실시간 HOT 키워드</dt>
                <dd>
                  <button>바지</button>
                  <button>바캉스</button>
                  <button>시즌오프</button>
                  <button>스윔웨어</button>
                  <button>원피스</button>
                  <button>초복</button>
                  <button>보양식</button>
                  <button>워터슈즈</button>
                  <button>치마</button>
                  <button>제철과일</button>
                  <button>브랜드파워</button>
                  <button>샌들</button>
                </dd>
              </dl>
            </div>
          </div>
        </div>
      </header>
      <div className={openDropDown ? "drop-btn-wrap btn-drop-open" : "drop-btn-wrap btn-drop-close"}>
        <div>
          <ul className="drop-menu">
            <li
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                goUserMng();
                setOpenDropDown(false);
              }}
              onMouseEnter={(e) => (e.currentTarget.style.fontWeight = "700")}
              onMouseLeave={(e) => (e.currentTarget.style.fontWeight = "400")}
            >
              사용자 관리
            </li>
            <li
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                goStatistic();
                setOpenDropDown(false);
              }}
              onMouseEnter={(e) => (e.currentTarget.style.fontWeight = "700")}
              onMouseLeave={(e) => (e.currentTarget.style.fontWeight = "400")}
            >
              이용 현황
            </li>
            <li
              style={{
                cursor: "pointer",
              }}
              onClick={() => {
                goSetting();
                setOpenDropDown(false);
              }}
              onMouseEnter={(e) => (e.currentTarget.style.fontWeight = "700")}
              onMouseLeave={(e) => (e.currentTarget.style.fontWeight = "400")}
            >
              키워드 관리
            </li>
          </ul>
        </div>
      </div>

      <SearchModal ref={searchModalRef} userState={props.userState} />
    </>
  );
};

export default forwardRef(Header);
